import styled from 'styled-components';
import Modal from 'react-modal';

export const UploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  height: 100%;
  min-height: 250px;
  color: #555;
`;

export const ImagePreview = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 15px;
  border: 2px solid #ddd;
  cursor: pointer;
`;

export const UploadButton = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  background-color: #003366;
  color: white;
  font-size: 14px;
  cursor: pointer;
  margin-top: 10px;
  &:hover {
    background-color: #002244;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding-top: 80px; 
  padding-bottom: 80px; 
`;

export const Form = styled.form`
  width: 100%;
  max-width: 800px;
  background: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
  margin: 20px auto;
`;

export const Title = styled.h1`
  color: #333;
  margin-bottom: 20px;
  text-align: center;
  font-size: 24px;
`;

export const InputGroup = styled.div`
  margin-bottom: 15px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-weight: bold;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  box-sizing: border-box;
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  box-sizing: border-box;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;

export const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #003366;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #002244;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;

  th, td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }

  th {
    background-color: #f0f0f0;
    color: #333;
  }

  tr:hover {
    background-color: #f1f1f1;
    cursor: pointer;
  }
`;

export const BackButton = styled.button`
    align-self: flex-start;
    margin-left: 5%;
    margin-bottom: 20px;
    background-color: transparent;
    border: none;
    font-size: 16px;
    color: #B22222;
    cursor: pointer;
    display: flex;
    align-items: center;

    &:hover {
        color: #800000;
    }
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 15px;
  flex-wrap: wrap; /* Permite que os itens quebrem para a próxima linha */
`;

export const FlexItem = styled.div`
  flex: 1;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 18px;
  height: 18px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  min-height: 80px;
  resize: vertical;
`;

export const ModuleSeparator = styled.div`
  border-top: 1px solid #ccc;
  margin: 20px 0;
  padding-top: 20px;
`;

export const ModuleTitle = styled.h3`
  color: #003366;
  margin-bottom: 15px;
  cursor: pointer;
  user-select: none;
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
`;

export const ToggleLabel = styled.span`
  font-weight: bold;
`;

export const ToggleSwitch = styled.div`
  position: relative;
  width: 50px;
  height: 25px;
  background-color: ${props => (props.isActive ? '#003366' : '#ccc')};
  border-radius: 25px;
  cursor: pointer;
  transition: background-color 0.3s;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${props => (props.isActive ? '27px' : '2px')};
    width: 21px;
    height: 21px;
    background-color: white;
    border-radius: 50%;
    transition: left 0.3s;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
`;

export const SmallButton = styled(Button)`
  padding: 5px 10px;
  font-size: 12px;
`;

export const InputGroup2 = styled(InputGroup)``;

export const Erro = styled.p`
  color: red;
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
  min-height: 20px;
`;

export const StyledModal = styled(Modal)`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 80%;
  width: 900px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  outline: none;
`;

export const ModalContent = styled.div`
  max-height: 60vh;
  overflow-y: auto;
`;